import React from 'react';
import { FollowOutput, IndexLocationWithAlign, Virtuoso, VirtuosoHandle } from 'react-virtuoso';

const ListFooter = () => <div style={{ height: 109 }}></div>;
const listComponents = { Footer: ListFooter } as const;

export interface QuirkVirtualListProps<T = unknown> {
	items?: (T | React.ReactNode)[];
	ItemComponent: React.FC<{ item: T; index?: number }>;
	testId?: string;
	ref?: React.MutableRefObject<VirtuosoHandle | null>;
	atBottomStateChange?: (atBottom: boolean) => void;
	atTopStateChange?: (atTop: boolean) => void;
	startReached?: (index: number) => void;
	endReached?: (index: number) => void;
	atBottomThreshold?: number;
	followOutput?: FollowOutput;
	initialTopMostItemIndex?: number | IndexLocationWithAlign;
	components?: Record<string, React.FC>;
	itemKey?: (item: T) => string;
}

function isReactNode(data: unknown): data is React.ReactNode {
	return React.isValidElement(data);
}

export const QuirkVirtualList: typeof QuirkVirtualListComponent = React.forwardRef<
	VirtuosoHandle,
	QuirkVirtualListProps
>(QuirkVirtualListComponent) as typeof QuirkVirtualListComponent;

export function QuirkVirtualListComponent<T>(
	{
		items = [],
		ItemComponent,
		testId,
		atBottomStateChange,
		atTopStateChange,
		followOutput,
		initialTopMostItemIndex,
		components = listComponents,
		itemKey
	}: QuirkVirtualListProps<T>,
	ref: React.ForwardedRef<VirtuosoHandle>
) {
	return (
		<Virtuoso
			data-test-id={testId}
			components={components}
			totalCount={items?.length}
			data={items}
			itemContent={(index, item) =>
				isReactNode(item) ? item : <ItemComponent item={item} key={itemKey?.(item) ?? index} index={index} />
			}
			ref={ref}
			atBottomStateChange={atBottomStateChange}
			atTopStateChange={atTopStateChange}
			atBottomThreshold={20}
			followOutput={followOutput}
			initialTopMostItemIndex={initialTopMostItemIndex ?? 0}
		/>
	);
}
